var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "footer footer-section" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "footer-list" }, [
            _c(
              "p",
              {
                staticClass: "p1",
                staticStyle: { "margin-top": "30px", "margin-bottom": "10px" }
              },
              [
                _c("span", [_vm._v("客服热线：0755-26788010")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "公司地址：深圳市南山区高新南七道深圳软件园T3-B 5楼502"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "p2", staticStyle: { "margin-bottom": "30px" } },
              [
                _c("span", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://beian.miit.gov.cn",
                        target: "_blank"
                      }
                    },
                    [_vm._v("粤ICP备15112126号")]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("2021 ©深圳市华商数据科技有限公司")]),
                _vm._v(" "),
                _c("span", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://saas-assets.usoftchina.com/docs/ISO27001.pdf",
                        target: "_blank"
                      }
                    },
                    [_vm._v("ISO27001信息安全管理体系认证")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "company-logo" }, [
              _c("img", {
                attrs: { src: "/static/img/usoft_weixin_qr.png", alt: "" }
              })
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278c512f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278c512f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = null
// module chunks = 